export default __webpack_public_path__ + "static/media/goalIcon.69c77d4a.png";